import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './i18n'
import errorMessages from './plugins/errorMessages'
import './assets/tailwind.css'
import axios from 'axios'

// Инициализация CSRF токена при загрузке приложения
async function initCSRF() {
  try {
    await axios.get('/api/csrf/', { withCredentials: true })
  } catch (error) {
    // Public pages remain usable if the initial CSRF request fails.
  }
}

// Инициализируем CSRF токен перед монтированием приложения
const isUltrasoundEmbed = window.location.pathname.replace(/\/$/, '') === '/api/ultrasound/embed'
;(isUltrasoundEmbed ? Promise.resolve() : initCSRF()).then(() => {
  createApp(App).use(router).use(i18n).use(errorMessages).mount('#app')
})
